const actions = {
  set_isLogin: ({
    commit
  }, data) => {
    commit('set_isLogin', data)
  },
  set_username: ({
    commit
  }, data) => {
    commit('set_username', data)
  },
  set_token: ({
    commit
  }, data) => {
    commit('set_token', data)
  },
  set_authMenu: ({
    commit
  }, data) => {
    commit('set_authMenu', data)
  },
  set_baseMenu: ({
    commit
  }, data) => {
    commit('set_baseMenu', data)
  },
  set_authButton: ({
    commit
  }, data) => {
    commit('set_authButton', data)
  },
  set_showMenuList: ({
    commit
  }, data) => {
    commit('set_showMenuList', data)
  },
  set_hasMenu: ({
    commit
  }, data) => {
    commit('set_hasMenu', data)
  }
}
export default actions
